export const WindowWidth = window.innerWidth;
export const WindowHeight = window.innerHeight;
